import Vue from 'vue';
import { Decimal } from 'decimal.js';
/**
 * @param  {number} value 处理前的价格，单位是分
 * @return {string} 参数值
 */
export default Vue.filter('price', function (value: number) {
    if (!value) {
        return '--';
    }

    const price = Number(new Decimal(value).div(100));
    return `¥ ${price}`;
});
